import { Pane, Spinner, Text } from "evergreen-ui";
import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import useControlHub from "../hooks/useControlHub";

function ReceiptReport() {
  const { api } = useControlHub();
  const [error, setError] = useState(null);

  let { id } = useParams();

  const showReceipt = useCallback(({ url }) => {
    if (!url) {
      setError("Receipt not found");
      return;
    }
    window.open(url, "_self");
  }, []);

  useEffect(() => {
    if (!id) return;

    api
      .getFile(id)
      .then((data) => showReceipt(data))
      .catch((error) => {
        setError("An error ocurred, try refresh the page or log in again.");
      });
  }, [api, id, showReceipt]);

  if (error) {
    return (
      <Pane
        height={240}
        alignItems="center"
        justifyContent="center"
        display="flex"
      >
        <Text color="muted">{error}</Text>
      </Pane>
    );
  }

  return (
    <Pane
      display="flex"
      alignItems="center"
      justifyContent="center"
      height={400}
    >
      <Spinner />
    </Pane>
  );
}

export default ReceiptReport;
